import { render, staticRenderFns } from "./xnysyccyc.vue?vue&type=template&id=2b5e4164&scoped=true&"
import script from "./xnysyccyc.vue?vue&type=script&lang=js&"
export * from "./xnysyccyc.vue?vue&type=script&lang=js&"
import style0 from "./xnysyccyc.vue?vue&type=style&index=0&id=2b5e4164&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5e4164",
  null
  
)

export default component.exports